if (typeof boostPFSThemeConfig !== 'undefined') {
  var boostPFSFilterConfig = {
    general: {
      limit: 48,
      loadProductFirst: false,
      numberFilterTree: 2,
      showLimitList: '24,36,48',
    },
    selector: {
      breadcrumb: '.breadcrumbs-container',
      avoidStickyHeader: '.site-header-main',
      endStickyMobile: '.site-footer-wrapper',
    },
  };
}

(function () {
  BoostPFS.inject(this);

  ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    if (!totalProduct) totalProduct = this.totalProduct;

    const images = data.images_info;
    const soldOut = !data.available;
    const onSale = data.compare_at_price_min > data.price_min;
    const priceVaries = data.price_min != data.price_max;
    const clientWishlistButtonHTML = window.Theme && window.Theme.settings && window.Theme.settings.client_wishlist_enabled === 'true'
      ? `<button
            type="button"
            class="client-wishlist-button client-wishlist-button--card"
            data-client-wishlist-toggle
            data-product-id="{{itemId}}"
            data-variant-id="{{clientWishlistVariant}}"
            data-product-title="{{clientWishlistTitle}}"
            data-product-url="{{clientWishlistUrl}}"
            data-product-image="{{clientWishlistImage}}"
            data-product-price="{{clientWishlistPrice}}"
            data-product-price-source="boost-major-v1"
            data-product-currency="{{clientWishlistCurrency}}"
            data-product-vendor="{{clientWishlistVendor}}"
            data-product-category="{{clientWishlistCategory}}"
            data-product-sku="{{clientWishlistSku}}"
            data-product-available="{{clientWishlistAvailable}}"
            aria-label="Add to wishlist"
            aria-pressed="false"
          ><svg width="20" height="18" viewBox="0 0 20 18" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 9.3023 3.00239 12.9284 10.0002 17.5C16.9988 12.9277 20 9.3023 20 6C20 2.47671 16.9881 0.5 14.5 0.5C12.9069 0.5 11.0509 1.22722 9.9996 2.5C8.94503 1.22499 7.0905 0.5 5.5 0.5C3.01189 0.5 0 2.47671 0 6ZM1 6C1 9.3023 4.4 12.5011 10.0002 16.3016C15.6 12.5 19 9.3023 19 6C19 3.41659 16.7379 1.5 14.5 1.5C12.415 1.5 11.0509 2.81276 9.9996 4.08554C8.94503 2.81054 7.58 1.5 5.5 1.5C3.26 1.4931 0.995525 3.42 1 6Z" fill="currentColor"/></svg></button>`
      : '';
    const sponsoredHTML =
      data.tags.includes('Sponsored') && !soldOut
        ? `<span class="product-sponsored-tag absolute left-4 top-4 z-10">${window.Theme.translations['product.badge.sponsored']}</span>`
        : '';
    let firstVariant = data.variants[0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      const paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (let i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) {
          firstVariant = data.variants[i];
          break;
        }
      }
    }
    let itemHtml = boostPFSTemplate.productGridItemHtml;
    itemHtml = itemHtml.replace(/{{sponsoredTagHTML}}/g, sponsoredHTML);
    if (clientWishlistButtonHTML) {
      itemHtml = itemHtml.replace('<div class="productitem--info">', clientWishlistButtonHTML + '<div class="productitem--info">');
    }
    let customClass = `imagestyle--${
      boostPFSConfig.custom.product_grid_image_crop && boostPFSConfig.custom.product_grid_image_style != 'natural'
        ? 'cropped-'
        : ''
    }${boostPFSConfig.custom.product_grid_image_style}`;
    if (onSale) customClass += ' productitem--sale';
    if (boostPFSConfig.custom.emphasize_price) customClass += ' productitem--emphasis';
    if (boostPFSConfig.custom.atc_display == 'always')
      customClass += ' show-actions--mobile';
    itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);
    let itemImages = '';
    if (images.length > 0) {
      if (images.length > 1 && boostPFSConfig.custom.product_grid_show_second_image) {
        itemImages += buildImage(images[1], '300x', 'productitem--image-alternate', index);
      }
      itemImages += buildImage(images[0], '300x', 'productitem--image-primary', index);
    } else {
      itemImages += buildImage(null, '300x', 'productitem--image-primary', index);
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);
    const itemThumbUrl =
      images.length > 0 ? Utils.optimizeImage(images[0].src, '512x') : boostPFSConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    let itemLabelsHtml = '';
    if (soldOut) {
      itemLabelsHtml += `<span class="productitem__badge productitem__badge--soldout">${boostPFSConfig.label.sold_out}</span>`;
    } else if (onSale && boostPFSConfig.custom.product_sales_badge) {
      const savePrice = data.compare_at_price_min - data.price_min;
      const percentSavePrice = Math.round((savePrice * 100) / data.compare_at_price_max);
      const percentSavePriceHtml = `<span data-price-percent-saved>${percentSavePrice}</span>`;
      itemLabelsHtml += '<span class="productitem__badge productitem__badge--sale" data-badge-sales';
      if (!onSale) itemLabelsHtml += 'style="display: none;"';
      itemLabelsHtml += '>';
      itemLabelsHtml += '<span data-badge-sales-range>';
      switch (boostPFSConfig.custom.product_sales_badge_style) {
        case 'percent':
          if (priceVaries) {
            itemLabelsHtml += boostPFSConfig.label.sale_percentage_range_html.replace(
              /{{ savings }}/g,
              percentSavePriceHtml
            );
          } else {
            itemLabelsHtml += boostPFSConfig.label.sale_percentage_single_html.replace(
              /{{ savings }}/g,
              percentSavePriceHtml
            );
          }
          break;
        case 'money':
          if (priceVaries) {
            itemLabelsHtml += boostPFSConfig.label.sale_money_range_html.replace(
              /{{ savings }}/g,
              Utils.formatMoney(savePrice)
            );
          } else {
            itemLabelsHtml += boostPFSConfig.label.sale_money_single_html.replace(
              /{{ savings }}/g,
              Utils.formatMoney(savePrice)
            );
          }
          break;
        default:
          itemLabelsHtml += boostPFSConfig.label.sale;
          break;
      }
      itemLabelsHtml += '</span></span>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
    let priceHtml = '';
    if (!data.tags.includes('Off-Market')) {
      const classVaries = priceVaries ? 'price--varies' : '';
      const visibleClass = onSale || boostPFSConfig.custom.emphasize_price ? 'visible' : '';
      priceHtml += `<div class="price productitem__price ${classVaries}">`;
      priceHtml += `<div class="price__compare-at ${visibleClass}" data-price-compare-container>`;
      const compare_at_price_html = `<span class="visually-hidden">${
        boostPFSConfig.label.price_original
      }</span><span class="money price__compare-at--single" data-price-compare>${Utils.formatMoney(
        data.compare_at_price_min
      )}</span>`;
      if (onSale) {
        var compare_at_price_range_html = '';
        if (boostPFSConfig.custom.price_range_format == 'default') {
          compare_at_price_range_html =
            `<span class="visually-hidden">${boostPFSConfig.label.price_original}</span>` +
            `<span class="money price__compare-at--min" data-price-compare-min>${Utils.formatMoney(
              data.compare_at_price_min
            )}</span>` +
            `-` +
            `<span class="visually-hidden">${boostPFSConfig.label.price_original}</span>` +
            `<span class="money price__compare-at--min" data-price-compare-max>${Utils.formatMoney(
              data.compare_at_price_max
            )}</span>`;
        } else {
          compare_at_price_range_html = boostPFSConfig.label.range_html.replace(/{{ price }}/g, compare_at_price_html);
        }
      }
      if (priceVaries && onSale && boostPFSConfig.custom.show_original && boostPFSConfig.custom.show_range) {
        priceHtml += compare_at_price_range_html;
      } else if (onSale && boostPFSConfig.custom.show_original) {
        priceHtml += compare_at_price_html;
      } else if (boostPFSConfig.custom.emphasize_price && boostPFSConfig.custom.include_spacer) {
        priceHtml += '<span class="price__spacer"></span>';
      } else if (boostPFSConfig.custom.show_original) {
        priceHtml += '<span class="money price__original" data-price-original></span>';
      }
      priceHtml += '</div>';
      if (boostPFSConfig.custom.include_hidden_price) {
        priceHtml += '<div class="price__compare-at--hidden" data-compare-price-range-hidden>';
        if (boostPFSConfig.custom.price_range_format == 'range') {
          priceHtml +=
            `<span class="visually-hidden">${boostPFSConfig.label.price_original}</span>` +
            `<span class="money price__compare-at--min" data-price-compare-min>${Utils.formatMoney(
              data.compare_at_price_min
            )}</span>` +
            `-` +
            `<span class="visually-hidden">${boostPFSConfig.label.price_original}</span>` +
            `<span class="money price__compare-at--min" data-price-compare-max>${Utils.formatMoney(
              data.compare_at_price_max
            )}</span>`;
        } else {
          priceHtml += boostPFSConfig.label.range_html.replace(/{{ price }}/g, compare_at_price_html);
        }
        priceHtml +=
          `<div class="price__compare-at--hidden" data-compare-price-hidden>` +
          `<span class="visually-hidden">${boostPFSConfig.label.price_original}</span>` +
          `<span class="money price__compare-at--single" data-price-compare>${Utils.formatMoney(
            data.compare_at_price_min
          )}</span>`;
        priceHtml += '</div>';
        priceHtml += '</div>';
      }
      priceHtml += `<div class="price__current ${
        boostPFSConfig.custom.emphasize_price ? 'price__current--emphasize ' : ''
      }${onSale ? 'price__current--on-sale ' : ''}" data-price-container>`;
      const price_html = Utils.formatMoney(data.price_min);
      if (priceVaries) {
        if (boostPFSConfig.custom.price_range_format == 'range') {
          priceHtml +=
            `<span class="money price__current--min" data-price-min>${Utils.formatMoney(data.price_min)}</span>` +
            `-` +
            `<span class="money price__current--min" data-price-max>${Utils.formatMoney(data.price_max)}</span>`;
        } else {
          priceHtml += boostPFSConfig.label.range_html.replace(/{{ price }}/g, price_html);
        }
      } else {
        if (onSale && boostPFSConfig.custom.show_original) {
          priceHtml += `<span class="visually-hidden">${boostPFSConfig.label.price_current}</span>`;
        }
        priceHtml += price_html;
      }
      priceHtml += '</div>';
      priceHtml += '</div>';
      if (boostPFSConfig.custom.include_unit_price && firstVariant.unit_price_measurement) {
        const total_quantity = `<span class="productitem__total-quantity" data-total-quantity>${
          firstVariant.unit_price_measurement.quantity_value
        }${firstVariant.unit_price_measurement.quantity_unit}</span>`;
        const unit_price = `<span class="productitem__unit-price--amount money" data-unit-price-amount>${Utils.formatMoney(
          firstVariant.price
        )}</span>`;
        let unit_measure = '<span class="productitem__unit-price--measure" data-unit-price-measure>';
        if (firstVariant.unit_price_measurement.reference_value !== 1) {
          unit_measure += firstVariant.unit_price_measurement.reference_value;
        } else {
          unit_measure += firstVariant.unit_price_measurement.reference_unit;
        }
        unit_measure += '</span>';
        priceHtml += '<div class="productitem__unit-price">';
        priceHtml += boostPFSConfig.label.price_per_unit_html
          .replace(/{{ total_quantity }}/g, total_quantity)
          .replace(/{{ unit_price }}/g, unit_price)
          .replace(/{{ unit_measure }}/g, unit_measure);
        priceHtml += '</div>';
      }
    } else {
      priceHtml = '';
    }
    let emphasizePriceHtml = '';
    let noEmphasizePriceHtml = '';
    if (boostPFSConfig.custom.emphasize_price) {
      emphasizePriceHtml += priceHtml;
    } else {
      noEmphasizePriceHtml += priceHtml;
    }
    if (!soldOut) {
      itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
      itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);
    } else {
      itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, '');
      itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, '');
    }
    let itemVendorHtml = '';
    if (boostPFSConfig.custom.show_vendor && data.vendor !== '') {
      itemVendorHtml += `<span class="productitem--vendor"><a href="${
        boostPFSConfig.shop.url
      }/collections/vendors?q=${Utils.encodeURIParamValue(data.vendor)}">${data.vendor}</a></span>`;
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
    const itemUrl = Utils.buildProductItemUrl(data);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemVariant}}/g, data.variants[0].id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemFullUrl}}/g, boostPFSConfig.shop.url + itemUrl);
    itemHtml = itemHtml.replace(/{{clientWishlistVariant}}/g, String((firstVariant && firstVariant.id) || ''));
    itemHtml = itemHtml.replace(/{{clientWishlistTitle}}/g, escapeAttribute(data.title));
    itemHtml = itemHtml.replace(/{{clientWishlistUrl}}/g, escapeAttribute(boostPFSConfig.shop.url + itemUrl));
    itemHtml = itemHtml.replace(/{{clientWishlistImage}}/g, escapeAttribute(itemThumbUrl));
    itemHtml = itemHtml.replace(/{{clientWishlistPrice}}/g, escapeAttribute(String(data.price_min)));
    itemHtml = itemHtml.replace(/{{clientWishlistCurrency}}/g, escapeAttribute(boostPFSConfig.shop.currency || ''));
    itemHtml = itemHtml.replace(/{{clientWishlistVendor}}/g, escapeAttribute(data.vendor || ''));
    itemHtml = itemHtml.replace(/{{clientWishlistCategory}}/g, escapeAttribute(data.product_type || ''));
    itemHtml = itemHtml.replace(/{{clientWishlistSku}}/g, escapeAttribute((firstVariant && firstVariant.sku) || ''));
    itemHtml = itemHtml.replace(/{{clientWishlistAvailable}}/g, String(!soldOut));
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, itemUrl);
    const itemDataSha256 = sha256(JSON.stringify(data.id));
    itemHtml = itemHtml.replace(/{{itemDataSha256}}/g, itemDataSha256);
    if (typeof Utils.compileShopifyProductVariables === 'function') {
      itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
    }
    if (typeof Utils.compileShopifyProductMetafield === 'function') {
      itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
    }
    return itemHtml;
  };

  function buildImage(imageInfo, size, className, index) {
    if (!imageInfo) {
      imageInfo = {
        src: boostPFSConfig.general.no_image_url,
        width: 480,
        height: 480,
        aspect_ratio: 1,
      };
    }
    const width = size.split('x')[0];
    let height = 0;
    if (imageInfo && imageInfo.aspect_ratio) {
      height = width * imageInfo.aspect_ratio;
    } else {
      height = 512;
    }
    let srcset = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='X' height='Y'></svg>";
    srcset = srcset.replace('X', width).replace('Y', height).replace(/ /g, '%20');
    const loadingAttr = index < 2 ? 'eager' : 'lazy';
    let html =
      `<img ` +
      `src="${Utils.optimizeImage(imageInfo.src, size)}" ` +
      `class="${className}" ` +
      `decoding="async" ` +
      `loading="${loadingAttr}" ` +
      `alt="{{itemTitle}}" ` +
      `data-rimg="lazy" ` +
      `data-rimg-scale="1" ` +
      `data-rimg-template="${Utils.optimizeImage(imageInfo.src, size)}" ` +
      `data-rimg-max="${imageInfo.width}x${imageInfo.height}" ` +
      `data-rimg-crop ` +
      `>`;
    html += '<div data-rimg-canvas></div>';
    return html;
  }

  function escapeAttribute(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    const currentPage = parseInt(Globals.queryParams.page);
    const totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    if (totalPage > 1) {
      let paginationHtml = boostPFSTemplate.paginateHtml;
      let previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink('page', currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      let nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      const beforeCurrentPageArr = [];
      for (let iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) beforeCurrentPageArr.unshift('...');
      if (currentPage - 4 >= 0) beforeCurrentPageArr.unshift(1);
      beforeCurrentPageArr.push(currentPage);
      const afterCurrentPageArr = [];
      for (let iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      let pageItemsHtml = '';
      const pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (let iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? boostPFSTemplate.pageItemSelectedHtml
              : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink('page', currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return '';
  };

  ProductPaginationDefault.prototype._onClickEvent = function (e) {
    e.preventDefault();
    Globals.internalClick = true;
    let page = new URL($(e.currentTarget).attr('href')).searchParams.get('page');
    (page && !isNaN(page)) || (page = 1);
    FilterApi.setParam('page', page);
    FilterApi.applyFilter();
    const offsetTop = 24;
    const { top } = this.$productList.offset();
    const siteHeaderHeight = $('.site-header-main').outerHeight();
    const navigationWrapper = $('.site-navigation-wrapper');
    const siteNavigationHeight = navigationWrapper.is(':visible') ? navigationWrapper.outerHeight() : 0;
    const totalOffset = top - (siteHeaderHeight + siteNavigationHeight + offsetTop);
    window.scrollTo({ top: totalOffset, behavior: 'smooth' });
  };

  ProductSorting.prototype.compileTemplate = function () {
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      const sortingArr = Utils.getSortingList();
      if (sortingArr) {
        let sortingItemsHtml = '';
        for (const k in sortingArr) {
          sortingItemsHtml += `<option value="${k}">${sortingArr[k]}</option>`;
        }
        const html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
        return html;
      }
      return '';
    }
  };

  ProductLimit.prototype.compileTemplate = function () {
    if (boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
      const numberList = Settings.getSettingValue('general.showLimitList');
      if (numberList != '') {
        let showLimitItemsHtml = '';
        const arr = numberList.split(',');
        for (let k = 0; k < arr.length; k++) {
          if (arr[k] == Globals.queryParams.limit) {
            showLimitItemsHtml += `<li><a class="utils-showby-item active" href="${arr[k]}">${arr[k]}</a></li>`;
          } else {
            showLimitItemsHtml += `<li><a class="utils-showby-item" href="${arr[k]}">${arr[k]}</a></li>`;
          }
        }
        const html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
        return html;
      }
    }
    return '';
  };

  ProductLimit.prototype.bindEvents = function () {
    const _this = this;
    jQ(`${Selector.topShowLimit} li a`).click(function (e) {
      event.preventDefault();
      Globals.internalClick = true;
      FilterApi.setParam('limit', jQ(this).attr('href'));
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter();
    });
  };

  Breadcrumb.prototype.compileTemplate = function (colData, apiData) {
    if (!colData) colData = this.collectionData;
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      const colInfo = colData.collection;
      const delimiter =
        '<span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"/></svg></span>';
      let breadcrumbHtml = `<a href="/">${boostPFSConfig.label.breadcrumb_home}</a> `;
      breadcrumbHtml += delimiter;
      breadcrumbHtml += ` <span>${colInfo.title}</span>`;
      return breadcrumbHtml;
    }
    return '';
  };

  ProductList.prototype.afterRender = function (data, eventType) {
    if (window.ClientWishlist) window.ClientWishlist.renderControls();
  };

  Filter.prototype.afterRender = function (data, eventType) {
    if (window.bcInitEmpire && typeof bcInitEmpire === 'function') {
      if (jQ('[data-section-type="static-recently-viewed"]').length > 0) {
        jQ('[data-section-type="static-recently-viewed"]').attr('data-section-type', 'bc-static-recently-viewed');
      }
      if (jQ('[data-section-type="static-header"]').length > 0) {
        jQ('[data-section-type="static-header"]').attr('data-section-type', 'bc-static-header');
      }
      bcInitEmpire();
      if (jQ('[data-section-type="bc-static-recently-viewed"]').length > 0) {
        jQ('[data-section-type="bc-static-recently-viewed"]').attr('data-section-type', 'static-recently-viewed');
      }
      if (jQ('[data-section-type="bc-static-header"]').length > 0) {
        jQ('[data-section-type="bc-static-header"]').attr('data-section-type', 'static-header');
      }
    }
    jQ('.boost-pfs-filter-mobile-footer .boost-pfs-filter-clear-all')
      .off('click')
      .on('click', function (e) {
        e.preventDefault();
        const currentFilterOptionIds = [];
        Object.keys(Globals.queryParams).forEach((queryParam) => {
          if (queryParam.startsWith(Globals.prefix)) {
            currentFilterOptionIds.push(queryParam);
          }
        });
        currentFilterOptionIds.forEach((filterOptionId) => {
          FilterApi.setParam(filterOptionId, null);
        });
        FilterApi.setParam('page', 1);
        const eventType = 'clearAll';
        const eventInfo = {};
        FilterApi.applyFilter(eventType, eventInfo);
      });
  };

  FilterTree.prototype.afterRender = function () {
    const html =
      '<button aria-label="Clear all filters" class="boost-pfs-filter-button boost-pfs-filter-clear-all">Tout retirer</button>';
    if (this.$element.find('.boost-pfs-filter-mobile-footer .boost-pfs-filter-clear-all').length == 0)
      this.$element.find('.boost-pfs-filter-mobile-footer').prepend(html);
    this.$element.find('.boost-pfs-filter-mobile-footer .boost-pfs-filter-show-result').html('Voir les résultats');
  };

  function sha256(ascii) {
    function rightRotate(value, amount) {
      return (value >>> amount) | (value << (32 - amount));
    }
    const maxWord = 2 ** 32;
    const lengthProperty = 'length';
    let i, j;
    let result = '';
    const words = [];
    const asciiBitLength = ascii[lengthProperty] * 8;
    let hash = (sha256.h = sha256.h || []);
    const k = (sha256.k = sha256.k || []);
    let primeCounter = k[lengthProperty];
    const isComposite = {};
    for (let candidate = 2; primeCounter < 64; candidate++) {
      if (!isComposite[candidate]) {
        for (i = 0; i < 313; i += candidate) {
          isComposite[i] = candidate;
        }
        hash[primeCounter] = (candidate ** 0.5 * maxWord) | 0;
        k[primeCounter++] = (candidate ** (1 / 3) * maxWord) | 0;
      }
    }
    ascii += '\x80';
    while ((ascii[lengthProperty] % 64) - 56) ascii += '\x00';
    for (i = 0; i < ascii[lengthProperty]; i++) {
      j = ascii.charCodeAt(i);
      if (j >> 8) return;
      words[i >> 2] |= j << (((3 - i) % 4) * 8);
    }
    words[words[lengthProperty]] = (asciiBitLength / maxWord) | 0;
    words[words[lengthProperty]] = asciiBitLength;
    for (j = 0; j < words[lengthProperty]; ) {
      const w = words.slice(j, (j += 16));
      const oldHash = hash;
      hash = hash.slice(0, 8);
      for (i = 0; i < 64; i++) {
        const w15 = w[i - 15],
          w2 = w[i - 2],
          a = hash[0],
          e = hash[4];
        const temp1 =
          hash[7] +
          (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) +
          ((e & hash[5]) ^ (~e & hash[6])) +
          k[i] +
          (w[i] =
            i < 16
              ? w[i]
              : (w[i - 16] +
                  (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) +
                  w[i - 7] +
                  (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10))) |
                0);
        const temp2 =
          (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) +
          ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2]));
        hash = [(temp1 + temp2) | 0].concat(hash);
        hash[4] = (hash[4] + temp1) | 0;
      }
      for (i = 0; i < 8; i++) {
        hash[i] = (hash[i] + oldHash[i]) | 0;
      }
    }
    for (i = 0; i < 8; i++) {
      for (j = 3; j + 1; j--) {
        const b = (hash[i] >> (j * 8)) & 255;
        result += (b < 16 ? 0 : '') + b.toString(16);
      }
    }
    return result;
  }

  Utils.getFilePath = function (fileName, extension, version) {
    var extension = typeof extension !== 'undefined' ? extension : 'png';
    var version = typeof version !== 'undefined' ? version : '';
    Globals.fileUrl = Globals.fileUrl.replace(/__/g, '//').replace(/_/g, '/');
    var filePath = Globals.fileUrl.split('?')[0];
    filePath += fileName + '.' + extension + (version ? ('?v=' + version) : '');
    return filePath;
  };
})();
